import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';
import APHWrapper from './APH';
import RegulationResultsWrapper from './RegulationResults';

const titleMap = {
    0: 'Regulação',
    1: 'APH'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <RegulationResultsWrapper />;
        case 1:
            return <APHWrapper />;
        default:
            return null;
    }
};

export const Regulation = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Regulação',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'APH',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};